import React, { useState, useEffect } from "react";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { PATTERNS } from "../../util/patterns";
import * as services from "../../store/service";
import { Notification } from "../common/Notification";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import * as LoginActions from "../../store/loginService/actions";
import * as LoginTypes from "../../store/loginService/types";
import { useAreServicesActive } from "../../util/CommonServices";
import { ezsServiceIds, idfServiceIds } from "../../config/UserServicesList";
import { GetServiceDetails } from "../../store/common";
import LegalDocumentContainer from "../LegalDocumentPages/LegalDocumentContainer";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNo } from "../../util/phoneNumberValidationUtil";

const CompleteFamilySetupStep2 = (props: { state: any; history: any; setState: any }) => {
    const dispatch = useDispatch();
    const updateFamilyMember = (familyMembers: any) => dispatch(LoginActions.actionCreators.updateFamilyMember(familyMembers));
    const switchFamilyAccount = (activeAccount: LoginTypes.IUserFamilyAccountInfo, familyMembers: LoginTypes.IUserFamilyAccountInfo[]) =>
        dispatch(LoginActions.actionCreators.switchFamilyAccount(activeAccount, props.history, familyMembers));
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const [loading, setLoading] = useState(false);
    const [isEFTChecked, setIsETFChecked] = useState(false);

    const isDarkWebMonitoringActive = useAreServicesActive([ezsServiceIds.businessDarkWebMonitoring, ezsServiceIds.darkWebMonitoring]);
    const medicalIdMonitoringServiceActive = useAreServicesActive([idfServiceIds.medicalAccountMonitoring]);
    const phoneMonitoringServiceActive = useAreServicesActive([idfServiceIds.phoneNumberMonitoring]);
    const emailAddressMonitoringActive = useAreServicesActive([idfServiceIds.emailAddressMonitoring]);

    const isMedicalIdMonitoringActive = isDarkWebMonitoringActive ? true : medicalIdMonitoringServiceActive;
    const isPhoneMonitoringActive = isDarkWebMonitoringActive ? true : phoneMonitoringServiceActive;
    const isEmailAddressMonitoringActive = isDarkWebMonitoringActive ? true : emailAddressMonitoringActive;

    const familyOffer = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState.familtOffer : null));
    const ezsFamilyOfferActive = familyOffer && familyOffer.familyChildOffer?.hasChildOffer ? familyOffer.familyChildOffer?.hasChildOffer : false;
    const subcustomerID = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.childSubcustomerIdToCompleteAccount ? state.loggedInUser.childSubcustomerIdToCompleteAccount : ""
    );
    const { getTermsOfUseURL } = LegalDocumentContainer();
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand == "true"
                ? true
                : false
            : false
    );
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));

    const checked = () => {
        if (isEFTChecked) {
            setIsETFChecked(false);
            return;
        }
        setIsETFChecked(true);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        GetServiceDetails(dispatch);
    }, []);

    const previousStep = () => {
        const data = getValues();
        props.setState({
            ...props.state,
            firstName: props.state.firstName,
            lastName: props.state.lastName,
            middleName: props.state.middleName,
            SSN: props.state.SSN,
            confirmSSN: props.state.confirmSSN,
            DOB: props.state.DOB,
            emails: data.emails,
            phone: data.phone,
            medicalId: data.medicalInsurance,
            step: 1,
        });
    };

    const { register, handleSubmit, errors, control, getValues, watch } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            emails: Boolean(props.state.emails) ? props.state.emails : [{ email: "" }],
            phone: Boolean(props.state.phone) ? props.state.phone : [{ phone: "", code: "+1" }],
            driversLicense: "",
            cardholderName: "",
            passport: "",
            medicalInsurance: props.state.medicalId ? props.state.medicalId : "",
            mothersMaidenName: "",
            isEFTChecked: false,
        },
    });

    const emailHandler = useFieldArray({
        control,
        name: "emails",
    });

    const phoneHandler = useFieldArray({
        control,
        name: "phone",
    });

    const secondStepSubmit = (data: any) => {
        if (ezsFamilyOfferActive) {
            submitEZSFamilyAccount(data);
        } else {
            submitIdfFamilyAccount(data);
        }
    };

    const submitEZSFamilyAccount = (data: any) => {
        const switchUserAccount = () => {
            const accountToSwitch = familyMembers.find((x) => x.subcustomerId === subcustomerID);
            setLoading(true);

            const requestBody = { SubcustomerId: accountToSwitch && accountToSwitch.subcustomerId ? accountToSwitch.subcustomerId : " " };
            services
                .switchFamilyAccount(requestBody)
                .then((data) => {
                    if (!data["hasError"] && data["familyMembers"]) {
                        if (accountToSwitch) {
                            switchFamilyAccount(accountToSwitch, data["familyMembers"]);
                        }
                    }
                })
                .catch(() => {
                    setLoading(false);
                });
        };

        const monitorPhone = [];
        if (data.phone && data.phone.length > 0) {
            for (let i = 0; i < data.phone.length; i++) {
                if (data.phone[i] && data.phone[i].phone) {
                    let phone = data.phone[i].phone;
                    phone = phone.replace("(", "");
                    phone = phone.replace(")", "");
                    phone = phone.replace(" ", "");
                    phone = phone.replace("-", "");
                    const phoneItem = {
                        phone: phone,
                        "monitor-id": null,
                        "record-id": null,
                    };

                    monitorPhone.push(phoneItem);
                }
            }
        }

        const monitorEmail = [];
        if (data.emails && data.emails.length > 0) {
            for (let i = 0; i < data.emails.length; i++) {
                if (data.emails[i] && data.emails[i].email) {
                    const EmailItem = {
                        email: data.emails[i].email,
                        "monitor-id": null,
                        "record-id": null,
                    };

                    monitorEmail.push(EmailItem);
                }
            }
        }

        const additionalInformation = data && data.medicalInsurance ? { "medical-insurance": { "medical-id": data.medicalInsurance } } : null;
        const currentFamilyAccount = familyMembers.find((x) => x.subcustomerId === subcustomerID);

        const requestBody = {
            ChildEmailAddress: currentFamilyAccount?.email,
            asset: {
                personalInformation: {
                    "first-name": props.state.firstName,
                    "middle-name": props.state.middleName,
                    "last-name": props.state.lastName,
                    "primary-email-address": monitorEmail[0] ? monitorEmail[0] : { email: null, "monitor-id": null, "record-id": null },
                    "additional-emails-address": monitorEmail.slice(1).length > 0 ? monitorEmail.slice(1) : [],
                    "primary-phone": monitorPhone[0] ? monitorPhone[0] : { phone: null, "monitor-id": null, "record-id": null },
                    "additional-phone": monitorPhone.slice(1).length > 0 ? monitorPhone.slice(1) : [],
                    "date-of-birth": props.state.DOB,
                    ssn: props.state.SSN,
                },
                additionalInformation: additionalInformation,
            },
        };

        setLoading(true);
        services
            .completeAccountSetupEZS(requestBody)
            .then((data) => {
                if (!data.hasError) {
                    Notification({
                        type: "success",
                        title: "Account Setup Completed",
                        message: "Account setup for " + props.state.firstName + " " + props.state.lastName + " is successfully completed.",
                    });
                    setLoading(true);
                    services
                        .getUserFamily()
                        .then((data) => {
                            if (!data["hasError"] && data["familyMembers"]) {
                                updateFamilyMember(data["familyMembers"]);
                                switchUserAccount();
                            }
                        })
                        .catch(() => {
                            setLoading(false);
                        });
                } else {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: "Account Setup Error",
                        message: "Could not complete account setup. Something went wrong.",
                    });
                }
            })
            .catch(() => {
                setLoading(false);
                Notification({
                    type: "error",
                    title: "Account Setup Error",
                    message: "Could not complete account setup. Something went wrong.",
                });
            });
    };

    const submitIdfFamilyAccount = (data: any) => {
        let monitors = [];
        if (data.medicalInsurance) {
            const medicalInsurance = {
                primary: data.medicalInsurance,
                type: "MedicalAccountMonitoring",
            };
            monitors.push(medicalInsurance);
        }

        if (data.emails && data.emails.length > 0) {
            for (let i = 0; i < data.emails.length; i++) {
                if (data.emails[i] && data.emails[i].email) {
                    const EmailItem = {
                        primary: data.emails[i].email,
                        type: "EmailAddressMonitoring",
                    };

                    monitors.push(EmailItem);
                }
            }
        }

        if (data.phone && data.phone.length > 0) {
            for (let i = 0; i < data.phone.length; i++) {
                if (data.phone[i] && data.phone[i].phone) {
                    let phone = data.phone[i].phone;
                    phone = phone.replace("(", "");
                    phone = phone.replace(")", "");
                    phone = phone.replace(" ", "");
                    phone = phone.replace("-", "");

                    const phoneItem = {
                        primary: phone,
                        type: "PhoneNumberMonitoring",
                    };

                    monitors.push(phoneItem);
                }
            }
        }

        const switchUserAccount = () => {
            const accountToSwitch = familyMembers.find((x) => x.userId === props.state.userID);
            const requestBody = {
                childAccountID: accountToSwitch && accountToSwitch.userId ? accountToSwitch.userId : " ",
            };
            setLoading(true);

            services
                .checkCompleteAccountSetup(requestBody)
                .then((data) => {
                    if (data.isAccountSetupCompleted) {
                        const requestBody = { SubcustomerId: accountToSwitch && accountToSwitch.subcustomerId ? accountToSwitch.subcustomerId : " " };

                        services
                            .switchFamilyAccount(requestBody)
                            .then((data) => {
                                if (!data["hasError"] && data["familyMembers"]) {
                                    if (accountToSwitch) {
                                        switchFamilyAccount(accountToSwitch, data["familyMembers"]);
                                    }
                                }
                            })
                            .catch(() => {
                                setLoading(false);
                            });
                    }
                })
                .catch(() => {
                    setLoading(false);
                });
        };

        const requestBody = {
            "monitor-primary-email": true,
            childAccountID: props.state.userID,
            "first-name": props.state.firstName,
            "last-name": props.state.lastName,
            "middle-initial": props.state.middleName,
            ssn: props.state.SSN,
            "check-ssn": props.state.confirmSSN,
            "date-of-birth": props.state.DOB,
            "tos-check": true,
            monitors: monitors,
            "family-members": [],
        };

        setLoading(true);

        services
            .completeAccountSetup(requestBody)
            .then((data) => {
                if (!data.hasError) {
                    Notification({
                        type: "success",
                        title: "Account Setup Completed",
                        message: "Account setup for " + props.state.firstName + " " + props.state.lastName + " is successfully completed.",
                    });
                    setLoading(true);
                    services
                        .getUserFamily()
                        .then((data) => {
                            if (!data["hasError"] && data["familyMembers"]) {
                                updateFamilyMember(data["familyMembers"]);
                                switchUserAccount();
                            }
                        })
                        .catch(() => {
                            setLoading(false);
                        });
                } else {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: "Account Setup Error",
                        message: "Could not complete account setup. Something went wrong.",
                    });
                }
            })
            .catch(() => {
                setLoading(false);
                Notification({
                    type: "error",
                    title: "Account Setup Error",
                    message: "Could not complete account setup. Something went wrong.",
                });
            });
    };

    useEffect(() => {
        disableFlag();
    }, []);

    const disableFlag = () => {
        setTimeout(() => {
            const elements = document.getElementsByClassName("PhoneInputCountry");
            if (elements && elements.length > 0) {
                try {
                    for (const el of elements) {
                        const childs = el.children;
                        if (childs[0].nodeName === "SELECT") {
                            const selectEl = childs[0] as HTMLSelectElement;
                            selectEl.disabled = true;
                        }
                    }
                } catch {}
            }
        }, 500);
    };

    return (
        <React.Fragment>
            <div className={loading ? "loading" : ""} id="preferences-form" aria-hidden="true">
                <form onSubmit={handleSubmit(secondStepSubmit)} id="complete-account-setup-one-form-container">
                    {isEmailAddressMonitoringActive &&
                        emailHandler.fields.map((item, index) => {
                            return (
                                <div className={`form-row inline row ${errors["emails"] && errors["emails"][index] && "status-error"}`} key={item.id}>
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">{index === 0 && <label htmlFor="label-email">Email</label>}</div>
                                    <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            id="label-email"
                                            placeholder="Email Address"
                                            name={`emails[${index}].email`}
                                            defaultValue={`${item!.email}`}
                                            ref={register({
                                                pattern: PATTERNS.EMAIL.pattern,
                                            })}
                                        />
                                        <div className="form-input-button">
                                            {emailHandler.fields && emailHandler.fields.length > 1 && (
                                                <button
                                                    type="button"
                                                    className="btn-default btn-icon-only btn-no-padding"
                                                    onClick={() => {
                                                        emailHandler.remove(index);
                                                        window.addToDataLayer({ event: "Remove Alternate Email" });
                                                    }}
                                                >
                                                    <span className="btn-icon">
                                                        <em className="las la-trash-alt"></em>
                                                    </span>
                                                    <span className="btn-text">Remove Alternate Email</span>
                                                </button>
                                            )}
                                        </div>
                                        {!!errors["emails"] && !!errors["emails"][index] && errors["emails"][index]!.email!.type === "pattern" && (
                                            <span className="form-error">Please enter valid email.</span>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    {isEmailAddressMonitoringActive && emailHandler.fields.length < 10 && (
                        <div className="form-row row">
                            <div className="col-xs-12 col-sm-8 col-no-gutter col-sm-offset-4">
                                <button
                                    type="button"
                                    className="btn-default btn-link btn-no-padding"
                                    onClick={() => window.addToDataLayer({ event: "Add Email Address" })}
                                >
                                    <span className="btn-icon">
                                        <em className="las la-plus"></em>
                                    </span>
                                    <span
                                        className="btn-text"
                                        onClick={() => {
                                            emailHandler.append({
                                                email: "",
                                            });
                                        }}
                                    >
                                        Add Email Address
                                    </span>
                                </button>
                            </div>
                        </div>
                    )}

                    {isPhoneMonitoringActive &&
                        phoneHandler.fields.map((item, index) => {
                            return (
                                <fieldset className="form-row inline" key={`phone-number-${index}`}>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">{index === 0 && <legend className="legend-label">Phone </legend>}</div>

                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="row ">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className="form-row row">
                                                        <div className="form-label sr-only col-xs-12  col-no-gutter">
                                                            <label htmlFor="label-phone-number">Number </label>
                                                        </div>
                                                        <div className="form-input col-xs-12  col-no-gutter">
                                                            {
                                                                <Controller
                                                                    name={`phone[${index}].phone`}
                                                                    control={control}
                                                                    defaultValue={item.phone ? item.phone : ""}
                                                                    className="inputbox"
                                                                    rules={{
                                                                        required: false,
                                                                        validate: (value) =>
                                                                            value
                                                                                ? isValidPhoneNo(
                                                                                      accountInfo && accountInfo.country ? accountInfo.country : "US",
                                                                                      value
                                                                                  )
                                                                                : true,
                                                                    }}
                                                                    render={({ onChange, value }) => (
                                                                        <PhoneInput
                                                                            value={value}
                                                                            onChange={onChange}
                                                                            international={false}
                                                                            addInternationalOption={false}
                                                                            defaultCountry={accountInfo && accountInfo.country ? accountInfo.country : "US"}
                                                                            countries={[accountInfo && accountInfo.country ? accountInfo.country : "US"]}
                                                                            id="label-phone-number"
                                                                            placeholder={"Phone"}
                                                                            maxLength={15}
                                                                            minLength={10}
                                                                        />
                                                                    )}
                                                                />
                                                            }

                                                            <div className="form-input-button">
                                                                {phoneHandler.fields && phoneHandler.fields.length > 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn-default btn-icon-only btn-no-padding"
                                                                        onClick={() => {
                                                                            phoneHandler.remove(index);
                                                                            window.addToDataLayer({ event: "Remove Alternate Phone" });
                                                                        }}
                                                                    >
                                                                        <span className="btn-icon">
                                                                            <em className="las la-trash-alt"></em>
                                                                        </span>
                                                                        <span className="btn-text">Remove Alternate Phone</span>
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {!!errors["phone"] &&
                                                                !!errors["phone"][index] &&
                                                                errors["phone"][index]!.phone!.type === "validate" && (
                                                                    <span className="form-error">Invalid format. Please enter a valid phone number.</span>
                                                                )}
                                                            {!!errors["phone"] &&
                                                                !!errors["phone"][index] &&
                                                                errors["phone"][index]!.phone!.type === "minLength" && (
                                                                    <span className="form-error">Invalid format. Phone Number must be 10 digits in length.</span>
                                                                )}
                                                            {!!errors["phone"] &&
                                                                !!errors["phone"][index] &&
                                                                errors["phone"][index]!.phone!.type === "maxLength" && (
                                                                    <span className="form-error">Invalid format. Phone Number must be 10 digits in length.</span>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            );
                        })}

                    {isPhoneMonitoringActive && phoneHandler.fields.length !== 10 && (
                        <div className="form-row row">
                            <div className="col-xs-12 col-sm-8 col-no-gutter col-sm-offset-4">
                                <button
                                    type="button"
                                    className="btn-default btn-link btn-no-padding"
                                    onClick={() => window.addToDataLayer({ event: "Add Phone Number" })}
                                >
                                    <span className="btn-icon">
                                        <em className="las la-plus"></em>
                                    </span>
                                    <span
                                        className="btn-text"
                                        onClick={() => {
                                            phoneHandler.append({ code: "+1", phone: "" });
                                            disableFlag();
                                        }}
                                    >
                                        Add Phone Number
                                    </span>
                                </button>
                            </div>
                        </div>
                    )}

                    {isMedicalIdMonitoringActive && (
                        <div className={`form-row inline row ${errors["medicalInsurance"] && "status-error"}`}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                <label htmlFor="label-medicalInsurance">Medical Insurance </label>
                            </div>
                            <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                <input
                                    type="text"
                                    name="medicalInsurance"
                                    defaultValue={""}
                                    className="inputbox"
                                    id="label-medicalInsurance"
                                    ref={register({ pattern: /^[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF]+$/, minLength: 4, maxLength: 30 })}
                                    maxLength={30}
                                    placeholder=""
                                />
                                {errors["medicalInsurance"] && errors["medicalInsurance"].type === "pattern" && (
                                    <span className="form-error">Invalid format. Medical Insurance can only include numbers and letters.</span>
                                )}
                                {errors["medicalInsurance"] && errors["medicalInsurance"].type === "minLength" && (
                                    <span className="form-error">
                                        Medical Insurance must be a minimum of 4 characters in length and can only include numbers and letters.
                                    </span>
                                )}
                                {errors["medicalInsurance"] && errors["medicalInsurance"].type === "maxLength" && (
                                    <span className="form-error">
                                        Medical Insurance must be a maximum of 30 characters in length and can only include numbers and letters.
                                    </span>
                                )}
                            </div>
                        </div>
                    )}

                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-8 col-no-gutter">
                            <div className="line-divider" style={{ marginTop: "1.5rem" }}></div>
                        </div>
                    </div>

                    <div className={`form-row inline row ${errors["isEFTChecked"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-8 col-no-gutter">
                            <div className="form-row no-margin">
                                <div className="form-input">
                                    <label className="form-checkbox-label" htmlFor="isEFTChecked">
                                        <input
                                            type="checkbox"
                                            id="isEFTChecked"
                                            name="isEFTChecked"
                                            ref={register({ required: true })}
                                            onChange={() => checked()}
                                            checked={isEFTChecked}
                                        />
                                        <span className="form-checkbox-label-text">
                                            I agree to the{" "}
                                            <span className="default_link">
                                                {hasSontiqBrand ? (
                                                    <a href="https://www.sontiq.com/terms-of-use/" target="_blank" rel="noreferrer">
                                                        Terms of Use
                                                    </a>
                                                ) : (
                                                    <a
                                                        href={getTermsOfUseURL()}
                                                        onClick={(e) => {
                                                            window.addToDataLayer({ event: "Complete Child Registration - Show TNC" });
                                                        }}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Terms of Use
                                                    </a>
                                                )}
                                            </span>
                                            .
                                        </span>
                                    </label>
                                    {errors["isEFTChecked"] && errors["isEFTChecked"].type === "required" && (
                                        <span className="form-error">You must agree the Terms of Use to continue.</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="margin-vertical-l"></div>

                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>

                        <div className="col-xs col-no-gutter flex-grow-null">
                            <ul className="list-inline list-reset">
                                <li className="margin-left-s">
                                    <button onClick={() => previousStep()} type="button" className="btn-default  btn-min-width">
                                        <span className="btn-text">Previous</span>
                                    </button>
                                    <button type="submit" className="btn-default btn-primary btn-min-width">
                                        <span className="btn-text">Save</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </form>
            </div>
        </React.Fragment>
    );
};

export default CompleteFamilySetupStep2;
